import React from 'react';

interface GoogleWorkspaceReferralButtonProps {
  style?: React.CSSProperties;
  align?: 'center' | 'left' | 'right';
}

export const GoogleWorkspaceReferralButton: React.FC<GoogleWorkspaceReferralButtonProps> = ({ style, align = 'center' }) => {
  const alignmentStyles: React.CSSProperties = {
    alignItems: align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'flex-start',
    textAlign: align === 'center' ? 'center' : align === 'right' ? 'right' : 'left',
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '0.4rem',
      margin: '1.5rem 0',
      ...alignmentStyles,
      ...style
    }}>
      <a 
        href="https://referworkspace.app.goo.gl/rtyL" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          transition: 'transform 0.3s ease, filter 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.03)';
          e.currentTarget.style.filter = 'drop-shadow(0 4px 12px rgba(124, 168, 176, 0.25))';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.filter = 'none';
        }}
      >
        <img 
          src="https://storage.googleapis.com/referworkspace-asset/img/digitalbuttons/digital_button_en.png" 
          alt="Get started with Google Workspace"
          style={{
            height: '38px',
            width: 'auto',
            display: 'block',
            borderRadius: '4px'
          }}
        />
      </a>
      <span style={{
        fontFamily: 'var(--font-mono)',
        fontSize: '0.58rem',
        letterSpacing: '0.05em',
        color: 'rgba(255, 255, 255, 0.45)',
        textTransform: 'uppercase',
        lineHeight: '1.3',
        maxWidth: '240px'
      }}>
        Official affiliate of the Google Workspace Referral Program
      </span>
    </div>
  );
};
